module.exports = __webpack_public_path__ + "img/poster-webinar-bg.2b300264.png";